<div class="card">
    <div class="card-header">
        <section>
            <h2 class="card-title">Inventory Aging</h2>
            <p class="subtitle">Ideally 70% or more of the inventory has been on the lot less than 30 days.</p>
        </section>
        <h3><span class="badge badge-{{level()}}">{{percent | percent}}</span></h3>
    </div>
    <div class="card-body">
        <canvas baseChart [data]="stats" [options]="options" [type]="'bar'"> </canvas>
    </div>
    <div class="card-footer">
        @if (this.latest) {
            <p>as of {{this.latest.day | date:'E MMM d, yyyy'}}</p>
        }
    </div>
</div>